const Footer = () => {
    return (
        <section className="footer">
            <div className="inner">
                    
            </div>
        </section>
      );
}

export default Footer;